import React from 'react'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { ZodiacCheckbox } from 'zodiac-ui-components'
import classNames from 'classnames'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { Sort, TableScrollSpacer } from './AssetsTable'

interface EnhancedTableProps {
  classes: Record<string, string>
  numSelected: number
  onRequestSort: (event: React.MouseEvent<unknown>) => void
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void
  order: Sort
  rowCount: number
}

interface HeadCell {
  id: string
  width?: string | number
  label: string
  bgColorHeader?: string
  bgColor?: string
}

const headCells: HeadCell[] = [
  { id: 'token', label: 'Token', width: '15%' },
  { id: 'gas', label: 'Gas Cost to Claim', width: '20%' },
  { id: 'holding', label: 'Asset Value', width: '30%' },
  { id: 'claimable', label: 'Claimable Value', width: '30%' },
]

export function EnhancedTableHead(props: EnhancedTableProps) {
  const { classes, onSelectAllClick, order, numSelected, rowCount, onRequestSort } = props

  return (
    <TableHead>
      <TableRow>
        <TableScrollSpacer className={classes.startScrollSpacer} />
        <TableCell padding="checkbox" className={classes.headerBorder}>
          <ZodiacCheckbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
            style={{ paddingLeft: '0' }}
          />
        </TableCell>
        {headCells.map((headCell) => {
          const sortable = headCell.id === 'claimable' || headCell.id === 'holding'
          return (
            <React.Fragment key={headCell.id}>
              <TableCell
                key={headCell.id}
                width={headCell.width}
                align="right"
                padding="normal"
                className={classNames(classes.headerCell, classes.headerBorder, {
                  [classes.bgColumn]: ['gas', 'claimable'].includes(headCell.id),
                })}
                style={{ backgroundColor: headCell.bgColorHeader || headCell.bgColor }}
                sortDirection={sortable ? order : false}
              >
                {sortable ? (
                  <TableSortLabel active={sortable} direction={order} onClick={onRequestSort}>
                    {headCell.label}
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  </TableSortLabel>
                ) : (
                  headCell.label
                )}
              </TableCell>
            </React.Fragment>
          )
        })}
        <TableScrollSpacer className={classes.endScrollSpacer} />
      </TableRow>
    </TableHead>
  )
}
